<div class="modal-header">
    <div class="row col-12">        
        <div class="modal-title col-10">
            <h3>Opret skabelon for {{ currentDepartment.name }} - [{{ currentDepartment.code }}]</h3>
        </div>
        <div class="col-2 align-self-center">
            <div class="text-end">
                <button type="button" class="btn" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
                    <span aria-hidden="true" ><i class="fa-solid fa-x"></i></span>
                </button>    
            </div>
        </div>
    </div>
</div>

<div class="modal-body col-12">
    @if(isLoading)
    {
        <div class="row">   
            <div class="d-flex flex-column justify-content-center align-items-center w-100">
                <div class="continuous-loader" role="status"></div>
                <h4 class="mt-2">{{ loadingText }}</h4>
            </div>
        </div>
    }
    @else
    {
    <div class="row">
        <div class="input-group">
            <div class="col-3">        
                <label class="me-3 mt-2 fw-bold">Databaseskabelon: </label>
            </div>
            <select class="form-select col-3" id="company-list-dbtables" placeholder="dbtabkes" (change)="ondbTableChange($event)">
                @for (option of dbTables; track $index) {
                    <option  [disabled]="option.id === ''" 
                                [value]="option.id "> {{ option.tableName }}</option>
                    }
            </select>
        </div>
    </div>
    <!-- <div class="row mt-2">
        <div class="input-group">
            <div class="col-3">
                <label class="me-3 mt-2 fw-bold">Skabelonnavn: </label>
            </div>
                <input type="text" class="form-control" id="template-name" 
                        [(ngModel)]="dbNameInput"
                        name="templatename" autocomplete="off" autofocus />
        </div>
    </div> -->
    }

    <div class="modal-footer bg-transparent">
        <button class="btn btn-success float-end" (click)="createTemplate()" [disabled]="disabled()" >
            @if(isCreateingTemplate)
            {
                <div class="spinner-border spinner-border-sm me-2" role="status">
                    <span class="visually-hidden">Opretter...</span>
                </div>
            }                    
            Opret skabelon</button> 
    </div>
</div>


